import React from "react"
import { Link } from "@reach/router"

import "./style/Navigation.css"
const Navigation = () => {
    return (
        <div className="nav">
            <Link to="/" className="nav-elem">
                HELLO
            </Link>
            <Link to="/programming" className="nav-elem">
                PROGRAMMING
            </Link>
            <Link to="/creative" className="nav-elem">
                CREATIVE
            </Link>
        </div>
    )
}
export default Navigation
